// DS: i5.1
import React from 'react';
import IconWrap from '../../IconWrap';
const BulletList = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M5.5 10c-.83 0-1.5.67-1.5 1.5S4.67 13 5.5 13 7 12.33 7 11.5c0-.781-.593-1.42-1.355-1.493L5.5 10zm0 6c-.83 0-1.5.67-1.5 1.5S4.67 19 5.5 19 7 18.33 7 17.5c0-.781-.593-1.42-1.355-1.493L5.5 16zm0-12C4.67 4 4 4.67 4 5.5S4.67 7 5.5 7 7 6.33 7 5.5c0-.781-.593-1.42-1.355-1.493L5.5 4zM9 12c0 .552.456 1 .995 1h8.01c.51 0 .93-.383.988-.883L19 12c0-.552-.456-1-.995-1h-8.01a.994.994 0 00-.988.883L9 12zm0 6c0 .552.456 1 .995 1h8.01c.51 0 .93-.383.988-.883L19 18c0-.552-.456-1-.995-1h-8.01a.994.994 0 00-.988.883L9 18zM9 6c0 .552.456 1 .995 1h8.01c.51 0 .93-.383.988-.883L19 6c0-.552-.456-1-.995-1h-8.01a.994.994 0 00-.988.883L9 6z"
    })));
};
BulletList.displayName = 'BulletList';
export default BulletList;

//# sourceMappingURL=BulletList.js.map